import { RootfiDataModelV4 } from '@commenda/types/src/root-fi/types';

export const V4_SCOPE_DESCRIPTIONS: Partial<Record<RootfiDataModelV4, string>> =
  {
    [RootfiDataModelV4.INVOICE]:
      'Invoice data including line items, amounts, and tax information',
    [RootfiDataModelV4.INVOICE_CREDIT_NOTE]:
      'Credit note information for invoices',
    [RootfiDataModelV4.BILL]:
      'Vendor bill data including line items, amounts, and tax information',
    [RootfiDataModelV4.BILL_CREDIT_NOTE]:
      'Credit note information for vendor bills',
    [RootfiDataModelV4.CONTACT]:
      'Customer and vendor contact information with addresses',
    [RootfiDataModelV4.ITEM]:
      'Product catalog with pricing and tax classifications',
    [RootfiDataModelV4.CASH_SALE]: 'Cash sales transactions and related data',
    [RootfiDataModelV4.CASH_REFUND]:
      'Cash refund transactions and related data',
    [RootfiDataModelV4.SALES_ORDER]:
      'Sales order data including line items, amounts, and tax information',
    [RootfiDataModelV4.ESTIMATE]:
      'Estimate data including line items, amounts, and tax information',
    [RootfiDataModelV4.ORDER]: 'E-commerce order management and tracking',
    [RootfiDataModelV4.BALANCE_SHEET]:
      'Financial balance sheet data and metrics',
    [RootfiDataModelV4.INCOME_STATEMENT]:
      'Income statement data including revenue, expenses, and net income',
    [RootfiDataModelV4.CASH_FLOW_STATEMENT]:
      'Cash flow statement data including cash inflows and outflows',
    [RootfiDataModelV4.COMPANY_INFO]:
      'Company information including names and addresses',
    [RootfiDataModelV4.CURRENCY]:
      'Currency data including exchange rates and conversion',
    [RootfiDataModelV4.JOURNAL_ENTRY]:
      'Journal entry data including descriptions and amounts',
    [RootfiDataModelV4.ACCOUNT]:
      'Account data including names and descriptions',
    [RootfiDataModelV4.TRACKING_CATEGORY]:
      'Tracking category data including names and descriptions',
  };

export const FALLBACK_SCOPE_DESCRIPTION =
  'Data synchronization scope for this integration';
